import React from 'react';
import PropTypes from 'prop-types';
import {inject} from 'mobx-react';
import {action, computed} from 'mobx';
import {Link} from 'react-router';
import autobind from 'autobind-decorator';

import {withI18n} from 'spa/Components/Context';

import ProgressiveBackgroundImage from 'spa/Components/ProgressiveBackgroundImage';

import ProgressiveImage from 'spa/Components/ProgressiveImage';

import 'spa/styles/home.less';
import '../../Home/HomeTherapistsSection.less';

@inject(({store: {screen, tracker}}) => ({
  screen,
  tracker,
}))
@withI18n
class HomeTherapistsSectionForDigital extends React.Component {
  static propTypes = {
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }),
    tracker: PropTypes.shape({
      track: PropTypes.func.isRequired,
    }).isRequired,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  @autobind
  @action('onClickAboutUs - HomeTreatmentsSectionForDigital')
  onClickAboutUs() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'About us',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked about us button', trackingData);
  }

  @autobind
  @action('onClickBookTreatment - HomeTreatmentsSectionForDigital')
  onClickBookTreatment() {
    const trackingData = {
      category: this.props.trackingCategory,
      label: 'Book a treatment',
    };

    if (this.props.trackingLocation) {
      trackingData.data = {
        page: this.props.trackingLocation,
      };
    }

    this.props.tracker.track('Clicked book a treatment button', trackingData);
  }

  render() {
    const {i18n} = this.context;
    const {screen: {isDesktop}} = this.props;

    return (
      <div className="home-therapists-section home-content-section row">
        <div className="home-content-section__cell home-content-section__cell-text home-content-section-for-digital__cell-text home-content-section__cell-text home-content-section__cell-text--extra-padded-left  home-content-section--pull-bottom">
          <div className="home-content-section__text-content home-content-section__text-content--wide">
            <h2 className="home-content-section__title home-content-section-for-digital__title">{i18n._x('Bringing a human touch to city life', 'Home therapist section title')}</h2>
            <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">{i18n._x('That\'s what we do with massages, but it\'s also how we do business.', 'Home therapist section paragraph')}</p>
            <p className="home-content-section__paragraph home-content-section-for-digital__paragraph">{i18n._x('Alongside helping you book treatments at the drop of a hat, we\'re proud to give therapists a fairer way to work. With Urban, they control their own hours and take home at least 70%% of what you pay.', 'Home therapist section paragraph')}</p>
            {i18n.safeLanguage === 'en' ? (
              <Link
                className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
                data-qa="home-tailored-section-button"
                onClick={this.onClickAboutUs}
                to={`/${i18n.lc}/about`}
              >
                About us
              </Link>
            ) : (
              <Link
                className="button button--primary button--tiny-wide home-content-section__button home-content-section-for-digital__button"
                data-qa="home-tailored-section-button"
                onClick={this.onClickBookTreatment}
                to={`/${i18n.lc}/treatments`}
              >
                {i18n._x('Book a treatment', 'Homepage about us button')}
              </Link>
            )}
          </div>
        </div>
        <ProgressiveBackgroundImage
          customClass="home-content-section__cell home-content-section__cell-image home-content-section-for-digital__cell-image home-therapists-section__cell-image"
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644313232/b2c-art/home-2022/home-fourth.jpg"
          highResImg=""
          highResImg2x=""
          mediaQueries={[
            {
              query: '(max-width: 768px)',
              highResImg: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_1440/v1644313232/b2c-art/home-2022/home-fourth.jpg',
              highResImg2x: 'https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_2160/v1644313232/b2c-art/home-2022/home-fourth.jpg',
            },
          ]}
        >
          {isDesktop && (
            <ProgressiveImage
              className="home-therapists-section__cell-image-element"
              lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,q_15,e_blur:2000/v1644313232/b2c-art/home-2022/home-fourth.jpg"
              highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_1440/v1644313232/b2c-art/home-2022/home-fourth.jpg"
              highResImg2x="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_2160/v1644313232/b2c-art/home-2022/home-fourth.jpg"
            />
          )}
        </ProgressiveBackgroundImage>
      </div>
    );
  }
}

export default HomeTherapistsSectionForDigital;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeTherapistsSectionForDigital.jsx